import { DocumentNode } from "@apollo/client";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IProfile } from "../../../@types/IProfile";
import { getHotels } from "../../../services/hotels";
import { AppDispatch, AppThunk } from "../../store";
import { trackLogin, trackLogout } from "../../../utils/tracking";

const _initialState: IProfile = {
  isLoggedOut: false,
  profile: {
    contact: null,
    hotels: [],
  },
};

const profileSlice = createSlice({
  name: "profile",
  initialState: _initialState,
  reducers: {
    setProfile: (state: any, { payload }: PayloadAction<any>) => {
      state.profile = payload;
      return state;
    },
    setIsLoggedOut: (state: any, { payload }: PayloadAction<any>) => {
      state = { ...state.profile, isLoggedOut: payload };
      return state;
    },
  },
});

export const profileReducer = profileSlice.reducer;
export const { setProfile } = profileSlice.actions;

export const addProfile =
  (email: string, query: DocumentNode): AppThunk =>
  async (dispatch: AppDispatch, _getState) => {
    if (email) {
      const profile = await getHotels(email, query);

      if (profile && !profile.error) {
        // Profile loaded successfully - trigger login tracking
        dispatch(profileSlice.actions.setProfile(profile));

        // Use brand email first, fallback to personal email, then MSAL email
        const trackingEmail =
          profile.contact?.brandEmail ||
          profile.contact?.personalEmail ||
          email;

        // Track login event now that we have the full profile data
        await trackLogin(trackingEmail, profile.contact);
      } else {
        // Handle error case
        dispatch(profileSlice.actions.setProfile(profile));
      }
    }
  };
export const setAuthStatus =
  (isLoggedOut: boolean): AppThunk =>
  async (dispatch: AppDispatch, getState) => {
    const currentState = getState();
    const currentProfile = currentState.profile?.profile;

    if (isLoggedOut && currentProfile?.contact) {
      // User is logging out - track logout event
      const userEmail =
        currentProfile.contact.brandEmail ||
        currentProfile.contact.personalEmail ||
        "";
      if (userEmail) {
        await trackLogout(userEmail);
      }
    }

    dispatch(profileSlice.actions.setIsLoggedOut(isLoggedOut));
  };
